import { useTheme } from "../OAS365Theme";

export const useUploadFilesItem = () => {
  const theme = useTheme();
  const UploadFilesItemStyle = {
    StackStyle: stack(theme),
    LabelNoDataStyle: LabelNoData(theme),
    LabelErrorDataStyle: LabelErrordata(theme),
    StackItemStyle: stackItem(theme),
    ViewCopyStackStyle: viewCopyStackItem(theme),
  };
  return UploadFilesItemStyle;
};

const stack = (theme) => {
  const style = {
    height: "100%",
  };
  return style;
};

const LabelNoData = (theme) => {
  const style = {
    textAlign: "center",
    color: theme.colors.subTitle,
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
  };
  return style;
};

const LabelErrordata = (theme) => {
  const style = {
    color: theme.colors.validationColor,
    textAlign: "center",
    fontSize: theme.fontSizes.normal,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeight.normal,
  };
  return style;
};

const stackItem = (theme) => {
  const style = {
    root: {
      "padding-top": "100px",
    },
  };
  return style;
};

const viewCopyStackItem = (theme) => {
  const style = {
    root: {
       "padding-top": "0px",
    },
  };
  return style;
};